// extracted by mini-css-extract-plugin
export var container = "_j0-0";
export var content = "_j0-3";
export var customerTitle = "_j0-4";
export var empty = "_j0-5";
export var gray = "_j0-6";
export var header = "_j0-7";
export var info = "_j0-8";
export var loading = "_j0-2";
export var loadingCard = "_j0-9";
export var oneLine = "_j0-a";
export var personName = "_j0-e";
export var pillContainer = "_j0-b";
export var selected = "_j0-1";
export var text = "_j0-c";
export var twoLines = "_j0-d";
export var unread = "_j0-f";
export var unreadIndicator = "_j0-g";